import { Controller } from '@hotwired/stimulus'

// Hides/shows fields based on whether a client's age (derived from a date input)
// falls below a threshold. Used to hide the phone number field for clients under 12.
export default class extends Controller {
  static targets = ['dateField', 'phoneField']
  static values = { minAge: { type: Number, default: 12 } }

  connect() {
    this.update()
  }

  update() {
    const value = this.dateFieldTarget.value
    if (!value) {
      this.phoneFieldTarget.classList.add('hidden')
      return
    }

    const dob = new Date(value)
    if (isNaN(dob.getTime())) {
      this.phoneFieldTarget.classList.add('hidden')
      return
    }

    const today = new Date()
    let age = today.getFullYear() - dob.getFullYear()
    const birthdayThisYear = new Date(today.getFullYear(), dob.getMonth(), dob.getDate())
    if (today < birthdayThisYear) age -= 1

    if (age < this.minAgeValue) {
      this.phoneFieldTarget.classList.add('hidden')
    } else {
      this.phoneFieldTarget.classList.remove('hidden')
    }
  }
}
